import CancelIcon from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip } from '@mui/material';
import { action, computed, makeObservable, observable, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import '../../css/botao.css';
import Configuracao from '../../util/Configuracao';
import ReactComponent from '../ReactComponent';
import IconeSubstituirParticipante from './IconeSubstituirParticipante';
import ProcuradorSessao from './ProcuradorSessao';

class ModalProcuradorSessao extends ReactComponent {
    aberto = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            aberto: observable,
            sessoes: computed,
            handleClickIconeComposicao: action,
            handleClickConfirmar: action,
            fecharDialog: action,
            atualizarProcuradorProcessos: action,
            callbackAutoCompleteProcurador: action,
            desabilitaBotaoSalvar: computed,
            desabilitaAlteracaoSIJ: computed
        });
    }

    get sessoes() {
        return this.observableProps.sessoes;
    }

    handleClickIconeComposicao = () => {
        this.aberto = true;
    };

    handleClickConfirmar = async () => {
        await this.gravarProcuradores();
        this.fecharDialog();
    };

    fecharDialog = () => {
        this.aberto = false;
    };

    async gravarProcuradores() {
        for (let index in this.sessoes.slice()) {
            let sessao = this.sessoes[index];
            if (sessao.origem === Configuracao.ORIGEM_PJE || !this.desabilitaAlteracaoSIJ) {
                if (sessao.procurador) {
                    console.log(
                        `Gravando procurador ${sessao.procurador.nome} (${sessao.procurador.codigo}) na sessão ${sessao.id} ...`
                    );
                    await this.sessaoService.gravarProcurador(sessao.id, sessao.procurador);
                } else {
                    console.log(`Excluindo procurador da sessão ${sessao.id} ...`);
                    await this.sessaoService.excluirProcurador(sessao.id);
                }

                this.atualizarProcuradorProcessos(sessao);
            }
        }

        this.mensagemStore.abrirMensagemSucesso('Operação realizada com sucesso.');
    }

    atualizarProcuradorProcessos(sessao) {
        if (this.sessaoStore.sessaoSelecionada) {
            let processos = this.salaSessaoStore.getProcessosSessao(sessao.id);
            processos = processos.filter((registro) => !registro.certidaoJulgamentoAssinada);
            processos.forEach((registro) => (registro.procurador = sessao.procurador));
        }
    }

    callbackAutoCompleteProcurador = (procurador, idSessao) => {
        let sessaoSelecionada = this.sessoes.find((sessao) => sessao.id === idSessao);
        if (sessaoSelecionada) {
            sessaoSelecionada.procurador = procurador;
        }
    };

    get desabilitaBotaoSalvar() {
        return (
            this.sessoes.findIndex((sessao) => sessao.origem === Configuracao.ORIGEM_PJE) === -1 &&
            this.desabilitaAlteracaoSIJ
        );
    }

    get desabilitaAlteracaoSIJ() {
        return (
            this.sessaoStore.processosSessao.findIndex(
                (registro) =>
                    registro.processo.origem === Configuracao.ORIGEM_SIJ && !registro.necessitaImportacaoSalaSessao
            ) === -1
        );
    }

    descricaoSessao() {
        let sessoes = toJS(this.sessoes);
        let retorno = '';

        if (sessoes && sessoes.length > 0) {
            sessoes.forEach((sessao) => {
                if (sessoes[sessoes.length - 1] === sessao) {
                    retorno += sessao.descricao;
                } else {
                    retorno += sessao.descricao + '; ';
                }
            });
        }

        return retorno;
    }

    render() {
        if (!this.isComponenteHabilitado('ModalProcuradorSessao')) {
            return null;
        }
        return (
            <>
                <Tooltip
                    title={'Editar procurador padrão da sessão'}
                    placement="top"
                    slotProps={{
                        popper: { style: { zIndex: '99999' } }
                    }}
                >
                    {this.observableProps.iconButton ? (
                        <IconButton
                            style={{ width: '48px', height: '48px' }}
                            className="corBotaoCinza"
                            onClick={this.handleClickIconeComposicao}
                            size="large"
                        >
                            <IconeSubstituirParticipante />
                        </IconButton>
                    ) : (
                        <Box
                            style={{
                                display: 'flex',
                                margin: '8px',
                                cursor: 'pointer',
                                fill: this.observableProps.corIcone
                            }}
                            className="corBotaoAmarelo"
                            onClick={this.handleClickIconeComposicao}
                        >
                            <IconeSubstituirParticipante />
                        </Box>
                    )}
                </Tooltip>
                {this.aberto && (
                    <Dialog
                        open={this.aberto}
                        maxWidth="xl"
                        onClose={this.fecharDialog}
                    >
                        <DialogTitle style={{ paddingBottom: '6px' }}>
                            Editar procurador padrão da(s) sessão(ões) <span>{this.descricaoSessao()}</span>
                        </DialogTitle>
                        <DialogContent style={{ paddingBottom: '6px' }}>
                            <ProcuradorSessao
                                callbackAutoComplete={this.callbackAutoCompleteProcurador}
                                sessoes={this.sessoes}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={this.fecharDialog}
                                color="secondary"
                                variant="outlined"
                                endIcon={<CancelIcon />}
                            >
                                Cancelar
                            </Button>
                            <Tooltip
                                placement="bottom"
                                title={
                                    this.desabilitaBotaoSalvar
                                        ? 'Não há processos do SIJ importados para alteração de procurador'
                                        : ''
                                }
                                slotProps={{
                                    popper: { style: { zIndex: 999999 } }
                                }}
                            >
                                <div>
                                    <Button
                                        onClick={this.handleClickConfirmar}
                                        color="primary"
                                        variant="outlined"
                                        endIcon={<SaveIcon />}
                                        disabled={this.desabilitaBotaoSalvar}
                                    >
                                        Salvar
                                    </Button>
                                </div>
                            </Tooltip>
                        </DialogActions>
                    </Dialog>
                )}
            </>
        );
    }
}

export default inject('stores')(observer(ModalProcuradorSessao));
